import DEFAULT_VALUES_LAYER from '../default'

const { page: DEFAULT_PAGE_LAYER, ...rest } = DEFAULT_VALUES_LAYER

export default {
  favoritesList: {
    ...rest,
    page: {
      ...DEFAULT_PAGE_LAYER,
      pageType: 'lista-de-favoritos',
      pageName: '/webmotors/comprar/lista-de-favoritos',
      pageNameTier2: 'lista-de-favoritos',
    },
  },
}
